var staticStrUndefined = require('./staticStrUndefined')

/* eslint-disable valid-typeof */
var staticLocation = typeof location === staticStrUndefined ? 0 : location

module.exports = staticLocation



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticLocation.js
// module id = 188
// module chunks = 106